import React, { useState, useRef } from 'react';
import Navbar from '../home/components/Navbar';
import Footer from '../home/components/Footer';

// --- 1. GÜNCEL 2025 LGS VERİ SETİ (Verdiğin Rapordan İşlendi) ---
const REAL_SCHOOL_DATA = [
  // TEKİRDAĞ (Detaylı - 2025 Verisi)
  { city: 'Tekirdağ', name: 'Ebru Nayim Fen Lisesi', type: 'Fen', score: 471.03, percentile: 1.59 },
  { city: 'Tekirdağ', name: 'Çorlu Borsa İstanbul Fen', type: 'Fen', score: 456.22, percentile: 3.43 },
  { city: 'Tekirdağ', name: 'Seval-Ahmet Çetin Fen', type: 'Fen', score: 450.45, percentile: 4.17 },
  { city: 'Tekirdağ', name: 'Tekirdağ Anadolu Lisesi', type: 'Anadolu', score: 441.83, percentile: 5.48 },
  { city: 'Tekirdağ', name: 'Çerkezköy Anadolu Lisesi', type: 'Anadolu', score: 407.03, percentile: 11.50 },
  { city: 'Tekirdağ', name: 'Mehmet Akif Ersoy And.', type: 'Anadolu', score: 406.70, percentile: 11.56 },
  { city: 'Tekirdağ', name: 'Namık Kemal Lisesi', type: 'Anadolu', score: 405.48, percentile: 11.79 },
  { city: 'Tekirdağ', name: 'Kapaklı Anadolu Lisesi', type: 'Anadolu', score: 392.98, percentile: 14.25 },
  { city: 'Tekirdağ', name: 'Mehmet Serez Sosyal Bil.', type: 'Sosyal', score: 389.34, percentile: 14.99 },
  { city: 'Tekirdağ', name: 'Trakya AİHL (Fen Prog)', type: 'İmam Hatip', score: 364.37, percentile: 20.44 },

  // ANKARA (2025 Zirve)
  { city: 'Ankara', name: 'Ankara Fen Lisesi', type: 'Fen', score: 494.52, percentile: 0.07 },
  { city: 'Ankara', name: 'Prof. Dr. Aziz Sancar Fen', type: 'Fen', score: 488.63, percentile: 0.27 },
  { city: 'Ankara', name: 'Ankara Pursaklar Fen', type: 'Fen', score: 487.64, percentile: 0.34 },
  { city: 'Ankara', name: 'Atatürk Anadolu Lisesi', type: 'Anadolu', score: 478.23, percentile: 0.90 },
  { city: 'Ankara', name: 'Özdemir Bayraktar Havacılık', type: 'Meslek', score: 477.27, percentile: 1.01 },
  { city: 'Ankara', name: 'Cumhuriyet Fen Lisesi', type: 'Fen', score: 476.28, percentile: 1.11 },
  { city: 'Ankara', name: 'ASELSAN MTAL', type: 'Meslek', score: 468.76, percentile: 1.82 },

  // İSTANBUL (2025 Zirve)
  { city: 'İstanbul', name: 'Galatasaray Lisesi', type: 'Anadolu', score: 500.00, percentile: 0.01 },
  { city: 'İstanbul', name: 'İstanbul Erkek Lisesi', type: 'Anadolu', score: 498.00, percentile: 0.02 },
  { city: 'İstanbul', name: 'Kabataş Erkek Lisesi', type: 'Anadolu', score: 497.00, percentile: 0.05 },
  { city: 'İstanbul', name: 'İst. Atatürk Fen (Alm)', type: 'Fen', score: 490.18, percentile: 0.10 },
  { city: 'İstanbul', name: 'Kartal AİHL', type: 'İmam Hatip', score: 488.40, percentile: 0.25 },
  { city: 'İstanbul', name: 'Çapa Fen Lisesi', type: 'Fen', score: 486.78, percentile: 0.38 },
  { city: 'İstanbul', name: 'Yaşar Acar Fen Lisesi', type: 'Fen', score: 481.77, percentile: 0.70 },
  { city: 'İstanbul', name: 'Teknopark İstanbul MTAL', type: 'Meslek', score: 468.10, percentile: 1.82 },

  // İZMİR (2025)
  { city: 'İzmir', name: 'İzmir Fen Lisesi', type: 'Fen', score: 492.09, percentile: 0.15 },
  { city: 'İzmir', name: 'Atatürk Lisesi (Alm)', type: 'Anadolu', score: 490.18, percentile: 0.20 },
  { city: 'İzmir', name: 'Bornova Anadolu Lisesi', type: 'Anadolu', score: 482.17, percentile: 0.50 },
  { city: 'İzmir', name: 'Buca İnci-Özer Tırnaklı', type: 'Fen', score: 475.08, percentile: 1.20 },
  { city: 'İzmir', name: 'İzmir Kız Lisesi', type: 'Anadolu', score: 472.35, percentile: 1.50 },

  // ÇANAKKALE & EDİRNE (Tahmini Aralıklar)
  { city: 'Çanakkale', name: 'Çanakkale Fen Lisesi', type: 'Fen', score: 458.60, percentile: 4.50 },
  { city: 'Çanakkale', name: 'Biga İÇDAŞ Fen Lisesi', type: 'Fen', score: 431.69, percentile: 7.20 },
  { city: 'Çanakkale', name: 'Merkez Çanakkale And.', type: 'Anadolu', score: 412.53, percentile: 10.50 },
  { city: 'Edirne', name: 'Süleyman Demirel Fen', type: 'Fen', score: 448.15, percentile: 4.52 },
  { city: 'Edirne', name: 'Keşan Fen Lisesi', type: 'Fen', score: 427.27, percentile: 7.87 },
  { city: 'Edirne', name: 'Edirne Lisesi', type: 'Anadolu', score: 418.49, percentile: 9.37 },
];

// 2025 Katsayıları
const COEFFICIENTS: Record<string, number> = {
  turkce: 4.35, mat: 4.25, fen: 4.15, inkilap: 1.68, din: 1.90, ing: 1.55
};
const BASE_POINT = 194.75;

const initialSubjects = [
  { id: 'turkce', name: 'Türkçe', q: 20, correct: 15, incorrect: 3 },
  { id: 'mat', name: 'Matematik', q: 20, correct: 10, incorrect: 2 },
  { id: 'fen', name: 'Fen Bilimleri', q: 20, correct: 14, incorrect: 4 },
  { id: 'inkilap', name: 'İnkılap Tar.', q: 10, correct: 8, incorrect: 1 },
  { id: 'ing', name: 'İngilizce', q: 10, correct: 9, incorrect: 1 },
  { id: 'din', name: 'Din Kültürü', q: 10, correct: 10, incorrect: 0 },
];

export default function AIEvaluationPage() {
  const [subjects, setSubjects] = useState(initialSubjects);
  const [result, setResult] = useState<any>(null);
  const [loading, setLoading] = useState(false);
  const [activeCity, setActiveCity] = useState('Tekirdağ');
  const resultRef = useRef<HTMLDivElement>(null);

  // --- HESAPLAMA MOTORU ---
  const handleInputChange = (id: string, field: 'correct' | 'incorrect', value: number) => {
    setSubjects(prev => prev.map(sub => {
      if (sub.id !== id) return sub;
      let newCorrect = field === 'correct' ? value : sub.correct;
      let newIncorrect = field === 'incorrect' ? value : sub.incorrect;
      if (newCorrect + newIncorrect > sub.q) {
        if (field === 'correct') newIncorrect = sub.q - newCorrect;
        else newCorrect = sub.q - newIncorrect;
      }
      return { ...sub, correct: Math.max(0, newCorrect), incorrect: Math.max(0, newIncorrect) };
    }));
  };

  const calculateNet = (correct: number, incorrect: number) => Math.max(0, correct - (incorrect / 3));

  const startAnalysis = () => {
    setLoading(true);
    setTimeout(() => {
      let rawScore = BASE_POINT;
      let mathNet = 0;
      let totalNet = 0;

      subjects.forEach(sub => {
        const net = calculateNet(sub.correct, sub.incorrect);
        if (sub.id === 'mat') mathNet = net;
        totalNet += net;
        rawScore += net * COEFFICIENTS[sub.id];
      });

      const finalScore = Math.min(500, Math.max(100, rawScore));

      // --- 2025 YÜZDELİK DİLİM ALGORİTMASI (Rapordaki Verilere Göre) ---
      // Ankara Fen (494) -> %0.07
      // Ebru Nayim (471) -> %1.59
      // Tekirdağ And (441) -> %5.48
      // Çerkezköy And (407) -> %11.50
      let percentile = 0;
      if (finalScore >= 494) percentile = 0.07;
      else if (finalScore >= 471) percentile = 0.07 + ((494 - finalScore) * (1.52 / 23)); 
      else if (finalScore >= 441) percentile = 1.59 + ((471 - finalScore) * (3.89 / 30));
      else if (finalScore >= 407) percentile = 5.48 + ((441 - finalScore) * (6.02 / 34));
      else percentile = 11.5 + ((407 - finalScore) * 0.5);

      // --- YAPAY ZEKA KOÇ YORUMU (Güncel Verilere Göre) ---
      let comment = { title: "", text: "", color: "blue", mood: "neutral" };

      if (finalScore > 490) {
        comment = {
          title: "Türkiye'nin Zirvesi!",
          text: `İnanılmaz! Puanın (${finalScore.toFixed(2)}) ile Galatasaray (%0.01), Ankara Fen (%0.07) ve İzmir Fen (%0.15) gibi Türkiye'nin en prestijli okulları doğrudan hedefimiz. Derece yapıyorsun!`,
          color: "emerald", mood: "happy"
        };
      } else if (finalScore > 471) {
        comment = {
          title: "Ebru Nayim Fen Lisesi Cepte!",
          text: `Tebrikler! Tekirdağ'ın zirvesi Ebru Nayim Fen Lisesi (471.03) için güvenli bölgedesin. Ayrıca İstanbul Yaşar Acar Fen ve Buca İnci-Özer Tırnaklı Fen liselerini de kazanabilirsin. Harika gidiyorsun.`,
          color: "emerald", mood: "happy"
        };
      } else if (finalScore > 456) {
        comment = {
          title: "Çorlu Borsa İstanbul Kazanılır!",
          text: `Gayet iyisin! Çorlu Borsa İstanbul Fen (456.22) ve Seval-Ahmet Çetin Fen Lisesi (450.45) şu an senin için kazanılabilir durumda. Ebru Nayim için biraz daha Matematik/Fen neti artırmamız lazım.`,
          color: "blue", mood: "happy"
        };
      } else if (finalScore > 441) {
        comment = {
          title: "Tekirdağ Anadolu Garantilendi",
          text: `Tekirdağ Anadolu Lisesi (441.83) barajını aştın. Ancak potansiyelin Seval-Ahmet Çetin Fen Lisesi'ni (450.45) zorlayacak seviyede. Ufak bir gayretle Fen Lisesi öğrencisi olabilirsin!`,
          color: "blue", mood: "happy"
        };
      } else if (finalScore > 407) {
        comment = {
          title: "Anadolu Liseleri Menzilde",
          text: `Çerkezköy Anadolu (407.03) ve Mehmet Akif Ersoy (406.70) şu an senin için çok rahat. Hedefi Tekirdağ Anadolu'ya (441) çevirmek için Matematik ve Fen derslerine ağırlık vermeliyiz.`,
          color: "orange", mood: "warning"
        };
      } else {
        comment = {
          title: "Hedef Yükseltme Zamanı",
          text: `Şu an Kapaklı Anadolu Lisesi (392.98) seviyesindeyiz. Nitelikli liseler için (400+) biraz daha çalışmalıyız. Özellikle Matematik ve Türkçe netlerini artırarak bu tabloyu değiştirebilirsin.`,
          color: "gray", mood: "neutral"
        };
      }

      // Özel Matematik Uyarısı
      if (mathNet < 8) {
        comment.text += " (Not: Matematik netin düşük görünüyor, Fen Lisesi için bunu en az 15'e çekmeliyiz!)";
        comment.color = "red";
        comment.mood = "critical";
      }

      setResult({ score: finalScore, percentile: percentile.toFixed(2), totalNet, comment });
      setLoading(false);
      setTimeout(() => resultRef.current?.scrollIntoView({ behavior: 'smooth' }), 100);
    }, 800);
  };

  return (
    <div className="min-h-screen bg-slate-50 font-poppins">
      <Navbar />

      {/* HEADER (SABİT KALDI) */}
      <div className="bg-[#1e293b] pt-32 pb-32 px-4 text-center rounded-b-[3rem] shadow-2xl relative overflow-hidden">
        <div className="absolute top-0 left-0 w-full h-full overflow-hidden opacity-20 pointer-events-none">
          <div className="absolute -top-24 -left-24 w-96 h-96 bg-indigo-500 rounded-full blur-[100px]"></div>
          <div className="absolute top-1/2 right-0 w-64 h-64 bg-purple-500 rounded-full blur-[80px]"></div>
        </div>
        <div className="relative z-10 max-w-4xl mx-auto">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-white/10 text-indigo-200 text-sm font-bold mb-6 backdrop-blur-sm border border-white/10">
            <i className="ri-bar-chart-grouped-line"></i> Güncel 2025 Verileri
          </div>
          <h1 className="text-4xl md:text-6xl font-bold text-white mb-6 font-space tracking-tight">
            LGS Performans <span className="text-transparent bg-clip-text bg-gradient-to-r from-indigo-400 to-purple-400">Analizi</span>
          </h1>
          <p className="text-lg text-slate-300 max-w-2xl mx-auto">
            Netlerini gir, 2025 LGS yerleştirme sonuçlarına göre (Tekirdağ, İstanbul, Ankara) analizini yapalım.
          </p>
        </div>
      </div>

      <main className="px-4 -mt-20 pb-20 relative z-20">
        <div className="max-w-6xl mx-auto grid grid-cols-1 lg:grid-cols-12 gap-8">
          
          {/* SOL TARA F: GİRİŞ PANELİ */}
          <div className="lg:col-span-5 lg:sticky lg:top-24 h-fit">
            <div className="bg-white rounded-2xl shadow-xl p-6 border border-gray-100">
              <div className="flex justify-between items-center mb-6 border-b pb-4">
                <h2 className="text-xl font-bold text-gray-800 flex items-center gap-2">
                  <i className="ri-edit-circle-line text-indigo-600"></i> Netlerini Gir
                </h2>
                <button onClick={() => setResult(null)} className="text-xs text-red-500 font-bold hover:underline">TEMİZLE</button>
              </div>
              
              <div className="space-y-5">
                {subjects.map((sub) => (
                  <div key={sub.id} className="group">
                    <div className="flex justify-between items-center mb-2">
                      <label className="text-sm font-bold text-gray-700">{sub.name}</label>
                      <span className="text-xs font-bold text-indigo-600 bg-indigo-50 px-2 py-0.5 rounded">
                        {calculateNet(sub.correct, sub.incorrect).toFixed(2)} Net
                      </span>
                    </div>
                    <div className="flex gap-3">
                      <div className="relative flex-1">
                        <input type="number" min="0" max={sub.q} value={sub.correct}
                          onChange={(e) => handleInputChange(sub.id, 'correct', parseInt(e.target.value)||0)}
                          className="w-full pl-2 pr-2 py-2 border border-gray-300 rounded-lg text-center font-bold text-gray-800 focus:border-green-500 focus:ring-1 focus:ring-green-500 outline-none transition-all"
                          placeholder="D"
                        />
                        <div className="absolute right-2 top-2.5 w-1.5 h-1.5 bg-green-500 rounded-full"></div>
                      </div>
                      <div className="relative flex-1">
                        <input type="number" min="0" max={sub.q} value={sub.incorrect}
                          onChange={(e) => handleInputChange(sub.id, 'incorrect', parseInt(e.target.value)||0)}
                          className="w-full pl-2 pr-2 py-2 border border-gray-300 rounded-lg text-center font-bold text-red-600 focus:border-red-500 focus:ring-1 focus:ring-red-500 outline-none transition-all"
                          placeholder="Y"
                        />
                        <div className="absolute right-2 top-2.5 w-1.5 h-1.5 bg-red-500 rounded-full"></div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>

              <button 
                onClick={startAnalysis} disabled={loading}
                className="w-full mt-8 py-4 bg-gray-900 hover:bg-indigo-700 text-white font-bold rounded-xl shadow-lg transition-all flex items-center justify-center gap-2"
              >
                {loading ? <><i className="ri-loader-4-line animate-spin"></i> Hesaplanıyor...</> : <><i className="ri-magic-line"></i> ANALİZ ET</>}
              </button>
            </div>
          </div>

          {/* SAĞ TARA F: SONUÇLAR (AKILLI KISIM) */}
          <div className="lg:col-span-7" ref={resultRef}>
            
            {!result ? (
              <div className="h-full min-h-[500px] bg-white rounded-2xl shadow-lg border border-gray-100 flex flex-col items-center justify-center text-center p-8">
                <div className="w-20 h-20 bg-indigo-50 rounded-full flex items-center justify-center mb-6">
                  <i className="ri-bar-chart-grouped-line text-4xl text-indigo-500"></i>
                </div>
                <h3 className="text-xl font-bold text-gray-800 mb-2">Analiz Bekleniyor</h3>
                <p className="text-gray-500 max-w-sm">
                  Sol taraftan netlerini girip butona tıkla. <br/>
                  <span className="font-semibold text-indigo-600">2025 LGS (Ağustos)</span> verileriyle seni değerlendireyim.
                </p>
              </div>
            ) : (
              <div className="space-y-6 animate-fade-in-up">
                
                {/* 1. KART: SKOR VE AI YORUMU */}
                <div className="bg-white rounded-2xl shadow-xl overflow-hidden border border-gray-100">
                  {/* Üst Kısım: Puan */}
                  <div className="bg-gradient-to-r from-indigo-800 to-indigo-900 p-8 text-white text-center relative overflow-hidden">
                    <div className="relative z-10">
                      <p className="text-indigo-200 text-xs font-bold tracking-widest uppercase mb-1">Tahmini 2025 LGS Puanı</p>
                      <h2 className="text-6xl font-black tracking-tight">{result.score.toFixed(3)}</h2>
                      <div className="mt-4 flex justify-center gap-4">
                        <div className="bg-white/10 px-4 py-2 rounded-lg backdrop-blur-sm border border-white/10">
                          <span className="block text-xs text-indigo-200">Tahmini Yüzdelik</span>
                          <span className="font-bold text-lg">%{result.percentile}</span>
                        </div>
                        <div className="bg-white/10 px-4 py-2 rounded-lg backdrop-blur-sm border border-white/10">
                          <span className="block text-xs text-indigo-200">Toplam Net</span>
                          <span className="font-bold text-lg">{result.totalNet.toFixed(2)}</span>
                        </div>
                      </div>
                    </div>
                    <i className="ri-trophy-fill absolute -bottom-6 -right-6 text-9xl text-white opacity-5"></i>
                  </div>

                  {/* Alt Kısım: Koç Yorumu */}
                  <div className={`p-6 border-l-8 ${
                    result.comment.color === 'emerald' ? 'border-emerald-500 bg-emerald-50' :
                    result.comment.color === 'red' ? 'border-red-500 bg-red-50' :
                    result.comment.color === 'orange' ? 'border-orange-500 bg-orange-50' :
                    'border-blue-500 bg-blue-50'
                  }`}>
                    <div className="flex gap-4">
                      <div className="mt-1"><i className="ri-user-voice-fill text-2xl opacity-70"></i></div>
                      <div>
                        <h4 className={`font-bold text-lg ${
                          result.comment.color === 'emerald' ? 'text-emerald-800' :
                          result.comment.color === 'red' ? 'text-red-800' :
                          result.comment.color === 'orange' ? 'text-orange-800' :
                          'text-blue-800'
                        }`}>{result.comment.title}</h4>
                        <p className="text-gray-700 mt-1 italic leading-relaxed text-sm">"{result.comment.text}"</p>
                      </div>
                    </div>
                  </div>
                </div>

                {/* 2. KART: GERÇEK OKUL LİSTESİ */}
                <div className="bg-white rounded-2xl shadow-lg border border-gray-200 overflow-hidden">
                  <div className="p-4 border-b border-gray-100 bg-gray-50 flex justify-between items-center flex-wrap gap-2">
                    <h3 className="font-bold text-gray-800 flex items-center gap-2">
                      <i className="ri-building-line text-indigo-500"></i> Kazanabileceğin Okullar
                    </h3>
                    <div className="flex bg-white rounded-lg p-1 border border-gray-200 overflow-x-auto">
                      {['Tekirdağ', 'İstanbul', 'Ankara', 'İzmir', 'Çanakkale', 'Edirne'].map(city => (
                        <button key={city} onClick={() => setActiveCity(city)}
                          className={`px-3 py-1 text-xs font-bold rounded-md transition-all whitespace-nowrap ${
                            activeCity === city ? 'bg-indigo-600 text-white shadow' : 'text-gray-500 hover:bg-gray-100'
                          }`}
                        >
                          {city}
                        </button>
                      ))}
                    </div>
                  </div>

                  <div className="overflow-x-auto max-h-[400px]">
                    <table className="w-full text-left text-sm">
                      <thead className="bg-gray-50 text-gray-500 text-xs uppercase sticky top-0 z-10">
                        <tr>
                          <th className="p-4 font-semibold border-b">Okul Adı</th>
                          <th className="p-4 font-semibold border-b text-right">2025 Puan</th>
                          <th className="p-4 font-semibold border-b text-center">Durum</th>
                        </tr>
                      </thead>
                      <tbody className="divide-y divide-gray-50">
                        {REAL_SCHOOL_DATA
                          .filter(s => s.city === activeCity)
                          .sort((a,b) => b.score - a.score)
                          .map((school, i) => {
                            const diff = result.score - school.score;
                            let status = { text: "Zor", bg: "bg-red-100", color: "text-red-700", icon: "ri-close-circle-fill" };
                            let rowClass = "opacity-50 grayscale-[0.5]";

                            if (diff >= 0) {
                              status = { text: "Kazanır", bg: "bg-emerald-100", color: "text-emerald-700", icon: "ri-checkbox-circle-fill" };
                              rowClass = "bg-emerald-50/20";
                            } else if (diff >= -5) {
                              status = { text: "Plase (Sınır)", bg: "bg-amber-100", color: "text-amber-700", icon: "ri-time-line" };
                              rowClass = "";
                            }

                            return (
                              <tr key={i} className={`hover:bg-gray-50 transition-colors ${rowClass}`}>
                                <td className="p-4">
                                  <div className="font-bold text-gray-800">{school.name}</div>
                                  <div className="text-xs text-gray-500">{school.type} • %{school.percentile}</div>
                                </td>
                                <td className="p-4 text-right font-mono font-medium text-gray-600">{school.score.toFixed(2)}</td>
                                <td className="p-4 text-center">
                                  <span className={`inline-flex items-center gap-1 px-2.5 py-1 rounded-full text-xs font-bold ${status.bg} ${status.color}`}>
                                    <i className={status.icon}></i> {status.text}
                                  </span>
                                </td>
                              </tr>
                            );
                          })}
                      </tbody>
                    </table>
                    {REAL_SCHOOL_DATA.filter(s => s.city === activeCity).length === 0 && (
                      <div className="p-8 text-center text-gray-400 text-sm">Bu şehir için kayıtlı veri yok.</div>
                    )}
                  </div>
                </div>

              </div>
            )}
          </div>

        </div>
      </main>

      <Footer />
    </div>
  );
}